export default __webpack_public_path__ + "static/media/Bg_2025_mobile.3a2d7c36.jpg";